import Rollbar from 'rollbar';

// Only initialize Rollbar in production and when token is available
const rollbarToken = process.env.GATSBY_ROLLBAR_TOKEN;
const isProduction = process.env.NODE_ENV === 'production';

let rollbar: Rollbar | null = null;

if (isProduction && rollbarToken) {
  rollbar = new Rollbar({
    accessToken: rollbarToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.NODE_ENV,
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: process.env.GATSBY_VERSION || '1.0.0',
        },
      },
    },
  });
}

export const logError = (error: Error | string, extra?: any) => {
  if (rollbar) {
    rollbar.error(error, extra);
  } else {
    console.error('Client Error:', error, extra);
  }
};

export const logWarning = (message: string, extra?: any) => {
  if (rollbar) {
    rollbar.warning(message, extra);
  } else {
    console.warn('Client Warning:', message, extra);
  }
};

export const logInfo = (message: string, extra?: any) => {
  if (rollbar) {
    rollbar.info(message, extra);
  } else {
    console.info('Client Info:', message, extra);
  }
};

export default rollbar;